import { useTranslation } from 'next-i18next';
import React from 'react';

import { useGetPrintingOrdersList } from '@/modules/packhouse/printingOrders/apiHooks';
import PrintingOrderRow from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders/PrintingOrderRow';
import { Loading } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface IProps {
  date: string;
}

const GeneralPrintingOrders = ({ date }: IProps) => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data: listing, isLoading } = useGetPrintingOrdersList({
    date,
    entityId: selectedAsset?.id,
  });

  if (listing?.length === 0 && !isLoading) {
    return <EmptyCard message={t('no-printing-orders')} variant='text' />;
  }
  return (
    <div className='flex flex-col gap-y-16'>
      {isLoading ? (
        <Loading />
      ) : (
        listing?.map((item, i) => (
          <PrintingOrderRow key={i} date={date} ordersData={item} />
        ))
      )}
    </div>
  );
};
export default GeneralPrintingOrders;
